import { ReactComponent as Triangle } from '../../../assets/svg/alert-triangle.svg';
import { Modal } from '../Modal';
import { ErrorContentProps, ErrorModalProps } from './types';


export function ErrorContent({ title, content, onClose }: ErrorContentProps) {
    return (
        <div className="form-message _error">
            <div className="form-message" style={{ textAlign: 'center' }}>
                <Triangle />
            </div>
            <h2 className="popup__heading form-message__heading" style={{ textAlign: 'center' }}>
                {title}
            </h2>
            <div className="form-message__copy" style={{ textAlign: 'center' }}>
                {content}
            </div>
            <div className="form-message__ok">
                <span className="btn" onClick={() => onClose()}>
                    OK
                </span>
            </div>
        </div>
    );
}

export function ErrorModal({ title, content, isOpen, onClose }: ErrorModalProps) {
    return (
        <Modal className={'popup_message'} isOpen={isOpen} onClose={() => onClose()}>
            <ErrorContent title={title} content={content} onClose={onClose} />
        </Modal >
    );
}
